import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class DashboardService {
    //For Service Types
    getUserInfo() {
        return axios.get(Config.apiBasePath + '/getLoggedInUser', {headers: authHeader()});
    }

    async googleData() {
        const response = await axios.get(Config.apiBasePath + '/googleAnalyticsData', {headers: authHeader()});
        return response;
    }

    async getAllDashboardData() {
        const response = await axios.get(Config.apiBasePath + '/getAllDashboardData', {headers: authHeader()});
        return response;
    }

    async getCareerCircularData() {
        const career_api = localStorage.getItem('carrer_api_url');
        const response = await axios.post(career_api + '/api/circular-list',
        );
        return response;
    }

    /*async googleData() {
        const response = await axios.get( 'http://192.168.78.145:9008/cms/api/v1/googleAnalyticsData', { headers: authHeader() });
        return response;
    }*/

    async googleRealTimeData() {
        const response = await axios.get(Config.apiBasePath + '/googleAnalyticsDataRealTime', {headers: authHeader()});
        return response;
    }

    /*async googleRealTimeData() {
        const response = await axios.get( 'http://192.168.78.145:9008/cms/api/v1/googleAnalyticsDataRealTime', { headers: authHeader() });
        return response;
    }*/

    async getMenus() {
        const response = axios.post(Config.apiBasePath + '/getMenuByRole', {}, {headers: authHeader()});
        /*const response = await axios.post(Config.apiBasePath + '/getMenuByRole', {headers: authHeader()});*/
        return response;
    }

    async getNotificationData() {
        const response = axios.get(Config.apiBasePath + '/getUnreadEmails', {headers: authHeader()});
        return response;
    }

    async getPaginatedNotificationData(param) {
        const response = await axios.post(Config.apiBasePath + '/getAllNotifications', null, {
            headers: authHeader(),
            params: param
        });
        return response;
    }

    async getAllNotificationData() {
        const response = axios.get(Config.apiBasePath + '/getAllNotifications', {headers: authHeader()});
        return response;
    }

    async updateNotificationStatusData() {
        const response = axios.post(Config.apiBasePath + '/markEmailAsRead', {}, {headers: authHeader()});
        return response;
    }

    async resendUserCreateEmail(id) {
        const response = axios.get(Config.apiBasePath + '/resendUserCreateEmail/' + id, {headers: authHeader()});
        return response;
    }

    async markSingleNotificationAsRead(id) {
        const response = axios.get(Config.apiBasePath + '/markSingleEmailAsRead/' + id, {headers: authHeader()});
        return response;
    }

    async getAllMenus() {
        const response = axios.get(Config.apiBasePath + '/fetchAllMenus', {headers: authHeader()});
        return response;
    }

    async getMenusByRoleId(id) {
        const response = axios.get(Config.apiBasePath + '/fetchMenuByRole?roleId=' + id, {headers: authHeader()});
        return response;
    }


}

export default new DashboardService();
